var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-container",attrs:{"id":"EmptyContent"}},[_c('img',{attrs:{"src":_vm.img,"alt":""}}),_c('p',{staticClass:"ft-grey"},[_vm._v(" "+_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }